<template>
  <v-list-item
    :class="computedClass"
    :data-active="active"
    :data-disabled="disable"
    :disabled="!isGroup && disable"
    @click="$emit('click')"
  >
    <template v-if="canSelect" #prepend>
      <v-checkbox hide-details readonly :disabled="disable" :model-value="active" />
    </template>

    <div class="ag-autocomplete__content">
      <v-list-item-title class="ag-autocomplete__item-title" :has-subtitle="!!subtitle">
        <AGTooltip direction="top start" :max-width="250" :tooltip-text="title">
          {{ title }}
        </AGTooltip>
      </v-list-item-title>

      <v-list-item-subtitle v-if="subtitle && !disable" class="ag-autocomplete__item-subtitle">
        {{ subtitle }}
      </v-list-item-subtitle>

      <v-list-item-subtitle v-else-if="disable && disableMessage" class="ag-autocomplete__item-subtitle">
        {{ disableMessage }}
      </v-list-item-subtitle>
    </div>

    <template v-if="$slots.action" #append>
      <slot name="action" />
    </template>
  </v-list-item>
</template>

<script>
import AGTooltip from '@/components/common/AGTooltip.vue';

export default {
  components: { AGTooltip },

  emits: ['click'],

  props: {
    title: {
      type: [String, Number],
      default: '',
    },

    subtitle: {
      type: [String, Number],
      default: '',
    },

    disableMessage: {
      type: String,
      default: '',
    },

    disable: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    canSelect: {
      type: Boolean,
      default: false,
    },

    isGroup: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    computedClass() {
      return this.isGroup ? 'ag-autocomplete__group' : 'ag-autocomplete__item';
    },
  },
};
</script>

<style scoped lang="scss">
.ag-autocomplete__item,
.ag-autocomplete__group {
  width: 100%;
  height: 64px !important;
  min-height: 64px;
  padding: $spacing-05 !important;
  cursor: pointer;

  &:hover {
    background-color: $brand-color-highlight-light !important;
  }

  &[data-disabled='true'] {
    background-color: $neutral-color-low-dark !important;
    cursor: default;
  }
}

.ag-autocomplete__item {
  background-color: $neutral-color-low-light;

  &[data-active='true'] {
    background-color: $brand-color-primary-light !important;
    opacity: 1 !important;
  }
}

.ag-autocomplete__group {
  background-color: $neutral-color-low-medium !important;
}

.ag-autocomplete__content {
  margin-left: $spacing-02;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: $spacing-01;

  .ag-autocomplete__item-title,
  .ag-autocomplete__item-subtitle {
    width: 100%;
    align-self: self-start;
    font-size: $font-size-xs;
    line-height: 1;
    margin: 0;
    display: block;
  }

  .ag-autocomplete__item-title {
    color: $neutral-color-high-dark;

    &[has-subtitle='true'] {
      font-weight: $font-weight-bold;
    }
  }

  .ag-autocomplete__item-subtitle {
    color: rgba(0, 0, 0, 0.6);
    opacity: 1;
  }
}

.v-list-item__action {
  margin-right: 4px !important;
}
</style>
